import React from 'react';
import { Radio } from '@domain-group/fe-co-form-elements';
import * as styles from './relationship-list.style';
import { relationships } from '../../types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var RelationshipList = _ref => {
  var selected = _ref.selected,
    _onChange = _ref.onChange;
  return ___EmotionJSX("ul", {
    css: styles.relationshipOptions
  }, relationships.map(relationship => ___EmotionJSX("li", {
    key: relationship.value,
    css: styles.relationshipType
  }, ___EmotionJSX(Radio, {
    css: styles.relationshipRadio,
    checked: relationship.value === selected,
    name: "relationship",
    value: relationship.value,
    labelContent: relationship.label,
    onChange: () => _onChange(relationship.value)
  }))));
};
export default RelationshipList;